import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues from 'utils/formatValues';

export const baseURI = 'tramites/requisitos-de-tramites/';

/**
 * GET Requisitos De Tramites
 * param {object} params
 * @returns {Promise<object>}
 */
export const getRequisitosDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data.map(({ documentos_de_tramite: docs = [], ...e }) => ({
      ...e,
      documentos_de_tramite: docs.length > 1 ? docs : docs[0],
    }));
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Requisito de Tramites
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getRequisitoDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Requisito de Tramites
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRequisitosDeTramites = async (_values) => {
  try {
    const values = getFormattedValues(_values);
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Requisito de Tramites
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRequisitosDeTramites = async (id, _values) => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Requisito de Tramites
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteRequisitosDeTramites = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
